import { render, staticRenderFns } from "./client-btns.vue?vue&type=template&id=27428536&scoped=true&"
import script from "./client-btns.vue?vue&type=script&lang=js&"
export * from "./client-btns.vue?vue&type=script&lang=js&"
import style0 from "./client-btns.vue?vue&type=style&index=0&id=27428536&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27428536",
  null
  
)

export default component.exports